<template>
    <div :class="['store-speed', $prefixClass.card]">
        <a-skeleton prefixCls="m-skeleton" :paragraph="{ rows: 6 }" active :loading="loading" button avatar>
            <div class="store-speed__content">
                <div class="store-speed__content__point">
                    <img :src="require(`../assets/store-speed-${displaySpeed}.svg`)" alt="">
                    <a-progress type="circle" :percent="progress" :width="87" :strokeWidth="10" 
                    :stroke-color="speed_color[displaySpeed]" 
                    class="store-speed__content__point__progress"/>
                    <div :class="['store-speed__content__point__speed', 'speed_' + displaySpeed]"><span>{{speed}}</span></div>
                </div>
                <div class="store-speed__content__detail">
                    <h5 class="m-b-8" v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.title`)"></h5>
                    <p v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.des`)"></p>
                    <template v-if="displaySpeed == '40_60'">
                        <ul class="list">
                            <li v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.order_${displayOrder}.line_1`)"></li>
                            <li v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.order_${displayOrder}.line_2`)"></li>
                        </ul>
                        <p>{{$t(`dashboard.store_speed.speed_${displaySpeed}.fa_experts`)}}</p>
                    </template>
                    <template v-else>
                        <ul class="list">
                            <li v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.order_${displayOrder}.line_1`)"></li>
                            <li v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.order_${displayOrder}.line_2`)"></li>
                            <li v-html="$t(`dashboard.store_speed.speed_${displaySpeed}.order_${displayOrder}.line_3`)"></li>
                        </ul>
                    </template>
                </div>
            </div>
        </a-skeleton>
        <div class="store-speed__footer" v-if="!loading">
            <template v-if="displaySpeed !== '61_100'">
                <a-button type="primary" @click="action">{{$t(`dashboard.store_speed.speed_${displaySpeed}.btn`)}}</a-button>
                <a :class="[$prefixClass.link]" target="_blank" href="https://support.fireapps.io/en/article/how-to-improve-your-speed-performance-l9p8zf/?bust=1651040921612#3-2-the-third-party-apps-you-use-for-your-stores-functionalities">{{$t(`app.buttons.learn_more`)}}</a>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StoreSpeed',
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        speed: {
            type: Number,
            required: true
        },
        order: {
            type: Number,
            required: true
        }
    },
    components: {
    },
    data() {
        return {
            active: true,
            size: 'default',
            progress: 0,
            modalDetailStoreSpeed: {
                visible: false
            },
            isRunProgress: false,
            speed_color: {
                "0_19": {
                    '0%': '#D70015',
                    '100%': '#FE3044 ',
                },
                "20_39": {
                    '0%': '#EF8F00',
                    '100%': '#F5AB3B',
                },
                "40_60": {
                    '0%': '#4FEA89',
                    '100%': '#37BF6A',
                }, 
                "61_100": {
                    '0%': '#39C16C',
                    '100%': '#21AA54',
                }, 
            }
        }
    },
    computed: {
        displaySpeed() {
            let speed = Number(this.speed);
            let show = "0_19"
            switch (true) {
                case speed <= 19:
                    show = "0_19"
                    break;
                case speed <= 39:
                    show = "20_39"
                    break;
                case speed <= 60:
                    show = "40_60"
                    break;
                case speed <= 100:
                    show = "61_100"
                    break;
            }
            return show;
        },
        displayOrder() {
            let order = Number(this.order);
            let show = "100"
            switch (true) {
                case order <= 100:
                    show = "100"
                    break;
                case order <= 300:
                    show = "300"
                    break;
                case order <= 500:
                    show = "500"
                    break;
                case order <= 1000:
                    show = "1000"
                    break;
                case order > 1000:
                    show = "more_1000"
                    break;
            }
            return show;
        }
    },
    created() {
        this.showProgress()
    },
    watch: {
        loading: {
            handler(val) {
                if (!val) {
                    this.showProgress()
                }
            },
            deep: true,
        },
    },
    methods: {
        action() {
            if (this.displaySpeed == "40_60") {
                this.openBoxChat()
            } else {
                this.$router.push({
                    name: this.$routerName['SWIFT_EXPERT'],
                })
            }
        },
        showProgress() {
            this.progress = 0
            if (!this.isRunProgress) {
                this.isRunProgress = true
                setTimeout(()=> {
                    let x = setInterval(()=> {
                        this.progress += 15
                        if (this.progress >= 75) {
                            clearInterval(x)
                            this.isRunProgress = false
                        }
                    }, 200)
                }, 500)
            }
        }
    }
}
</script>
<style lang="scss">
    .store-speed {
        box-shadow: 0px 6px 24px -6px #DCE5F4;
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 20px;
        .#{$skeleton} {
            &-avatar {
                width: 107px;
                height: 142px;
                border-radius: 20px 20px 0 0 !important;
            }
        }
        &__content {
            display: flex;
            flex-grow: 1;
            font-size: 16px;
            min-height: 175px;
            &__point {
                margin-top: 8px;
                width: 107px;
                position: relative;
                &__speed {
                    position: absolute;
                    font-weight: 700;
                    font-size: 30px;
                    line-height: 40px;
                    top: 38px;
                    width: 107px;
                    text-align: center;
                    &.speed_0_19 {
                        color: #B60012;
                    }
                    &.speed_20_39 {
                        color: #E19200;
                    }
                    &.speed_40_60 {
                        color: #015621;
                    }
                    &.speed_61_100 {
                        color: #015621;
                    }
                }
                &__progress {
                    position: absolute;
                    top: 17px;
                    left: 10px;
                    .a-progress-inner {
                        transform: rotate(224deg);
                        svg {
                            .a-progress-circle-trail {
                                stroke: transparent !important;
                            }
                        }
                    }
                    .a-progress-text {
                        display: none;
                    }
                }
            }
            &__detail {
                margin-left: 24px;
                width: calc(100% - 131px);
                ul.list {
                    list-style: none;
                    li {
                        margin-bottom: 8px;
                        &::before {
                            content: "\2022";
                            color: $primary-color;
                            display: inline-block;
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 24px;
                            margin: 0 8px 0 0;
                            width: 8px;
                        }
                    }
                }
            }
        }
        &__footer {
            margin-left: 131px;
            .#{$btn} {
                height: 40px;
            }
            .#{$link} {
                color: $text-color !important;
                margin-left: 24px;
                font-weight: 600;
            }
        }
    }
</style>